exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multi-checkbox{list-style:none;height:auto;width:100%;overflow:hidden auto;border:1px solid #e7e9ee;border-radius:2px}.multi-checkbox .multi-checkbox__item{margin:12px}", ""]);

// exports
